// Pure phone-composition helpers, kept out of phone-input.tsx so they can be
// exercised directly without a JSX toolchain.

/**
 * Digits of the national part, without the trunk prefix. Ghanaian (and most
 * African) numbers are written locally as `0XX XXX XXXX`, but the leading `0`
 * is a domestic dialling prefix that must not survive into an E.164 number:
 * `0546977782` with dial code 233 is `+233546977782`, never `+2330546977782`.
 * The server canonicalises the same way (`canonicalizePlatformPhoneNumber`),
 * so composing it here keeps what the customer is shown identical to what is
 * actually dialled.
 */
export function nationalDigits(phone: string): string {
  return phone.replace(/[^0-9]/g, '').replace(/^0+/, '');
}

/** Compose an E.164 number from a locally-typed number and a dial code. */
export function formatPhoneWithCountry(phone: string, dialCode: string): string {
  const cleaned = nationalDigits(phone);
  return cleaned ? `+${dialCode}${cleaned}` : '';
}
